import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    CircularProgress,
} from "@chakra-ui/react"

export default function LoadingModal({ isOpen, size}) {

    return (
        <Modal
            isOpen={isOpen}
            isCentered
            closeOnOverlayClick={false}
            size={size}
        >
            <ModalOverlay style={{ backgroundColor: 'transparent' }} />
            <ModalContent display='flex' justifyContent='center' alignItems='center' style={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none', outline: 'none' }}>
                <ModalBody width='fit-content'>
                    <CircularProgress size='50px' isIndeterminate />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}